import { ExcelStyle } from 'ag-grid-community';
import { MetricType } from 'components/common/types/DrilldownReports.types';

export const AVAILABILITY_PERCENT_EXCEL_STYLE_ID = 'availability-percent';

export const AVAILABILITY_PERCENT_EXCEL_STYLE: ExcelStyle = {
  id: AVAILABILITY_PERCENT_EXCEL_STYLE_ID,
  numberFormat: {
    format: '0.00%',
  },
};

export const getAvailabilityDataCellClass = (metricType: MetricType): string | string[] =>
  metricType === MetricType.SOT ? ['data-cell', AVAILABILITY_PERCENT_EXCEL_STYLE_ID] : 'data-cell';

export const ROW_GROUP_COLUMNS = [
  { code: 'productFormat', name: 'Product Format', colId: 'product-format', field: 'productFormat.name' },
  { code: 'businessAreaCodes', name: 'Business Area', colId: 'business-area', field: 'businessArea.name' },
  { code: 'revenueStreamCodes', name: 'Revenue Stream', colId: 'revenue-stream', field: 'revenueStream.name' },
  { code: 'sizeCodes', name: 'Size', colId: 'size', field: 'size.name' },
  { code: 'districtCodes', name: 'District', colId: 'district', field: 'district.name' },
  { code: 'networkCodes', name: 'Network', colId: 'network', field: 'network.name' },
  { code: 'townCodes', name: 'Town', colId: 'town', field: 'town.name' },
];
